exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--chip__3Tht2{font-weight:600}\n", ""]);

// exports
exports.locals = {
	"chip": "styles--chip__3Tht2"
};